import React from "react";
import { useTheme } from "../../context/ThemeContext";
import "./ThemeToggle.css";

function ThemeToggle() {
  const { isDark, toggleTheme } = useTheme();

  return (
    <button
      className="theme-toggle"
      onClick={toggleTheme}
      aria-label="Toggle theme"
    >
      <div className={`toggle-track ${isDark ? "dark" : "light"}`}>
        <span className="toggle-icon sun" role="img" aria-label="Light mode">
          ☀️
        </span>
        <span className="toggle-icon moon" role="img" aria-label="Dark mode">
          🌙
        </span>
        <div className="toggle-thumb" />
      </div>
    </button>
  );
}

export default ThemeToggle;
